import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "account-tab-container" }
const _hoisted_2 = { class: "account-tab-content" }

import { computed } from 'vue'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountTypeTab',
  setup(__props) {

const store = useStore<any>()

const accountTab = [
  { label: '证劵', value: 'STOCK' },
  { label: '基金', value: 'FUND' },
  { label: '债券', value: 'BOND' },
  { label: '结构化票据', value: 'SPS' },
  { label: '其他', value: 'OTHER' }
]

const marketTypeMap: Record<string, { label: string, value: string } | undefined> = {
  STOCK: { label: '港股', value: 'HK' },
  FUND: { label: '港元账户', value: 'HKD' },
  BOND: { label: '港元债券', value: 'HKD' }
}

const activeTab = computed({
  get: () => store.state.holdings.accountTypeActive?.value ?? 'STOCK',
  set: () => {}
})

const handleTabChange = (value: string | number) => {
  const tab = accountTab.find(item => item.value === value)
  if (!tab) return

  const marketType = marketTypeMap[tab.value]
  if (marketType) {
    store.commit(HoldingsMutationTypes.SET_MARKET_TYPE_ACTIVE, marketType)
  }
  store.commit(HoldingsMutationTypes.SET_ACCOUNT_TYPE_ACTIVE, tab)
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      onTabChange: handleTabChange
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(accountTab, (item) => {
          return _createVNode(_component_el_tab_pane, {
            key: item.value,
            label: item.label,
            name: item.value
          }, null, 8, ["label", "name"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})